import axios, { AxiosResponse } from 'axios';
import { FetchHashLoungesTypeWdw } from '../redux/lounges/slice';
import { Lounge } from '../redux/lounges/types';
import { GET_BASE_URL } from '../constants/apiEndpoints';
export const getHashLoungesApiWdw = async ({
  sortType,
  LoungeId,
  currentPage,
  tagValue,
  shortByTime,
}: FetchHashLoungesTypeWdw) => {
  const normalizedTagValue = `${tagValue ?? ''}`.replace(/^#/, '').trim();
  if (!normalizedTagValue) {
    return [];
  }

  const responseBody = (response: AxiosResponse) => response.data;
  localStorage.setItem('pagename', normalizedTagValue);

  const sortByTime = shortByTime === 'true' ? `&sortordefault=ww` : '';
  const apiEndpoint =
    GET_BASE_URL +
    `/api/v1/hashWdw?hash=${encodeURIComponent(normalizedTagValue)}` +
    sortByTime;

  const { data } = await axios
    .get<Lounge[]>(`${apiEndpoint}`)
    .then(responseBody);
  return data;
};
